/**
 * メッセージ変換
 * (C)2024 Chubu Electric Power Grid Co.,Inc. All Rights Reserved.
 * version 1.00 NEC 2024/12/31 初版
 */
import React from 'react';
import {useIntl} from 'react-intl';

/**
 * メッセージ変換
 * @param {*} Component コンポーネント
 * @return {*} コンポーネント
 */
export default function withFormatMessage(Component) {
  function ComponentWithMessageProp(props) {
    const intl = useIntl();
    const getMessageId = function(messageId) {
      return 'message.' + messageId;
    };
    const getMessage = function(messageId, values=null) {
      let message = '';
      if (!messageId) {
        return message;
      }
      const msgId = 'message.' + messageId;
      if (values) {
        message = intl.formatMessage({id: msgId}, values);
      } else {
        message = intl.formatMessage({id: msgId});
      }
      return message;
    };
    return (
      <Component
        {...props}
        {...{intl, getMessageId, getMessage}}
      />
    );
  }

  return ComponentWithMessageProp;
};

